/**
 * @name SecurityFooter
 * @description Footer com informações de segurança e certificação
 * @author Gabriel M. Guimarães | gabrielmg7
 */

import { Lock as LockIcon, Security as SecurityIcon, Shield as ShieldIcon } from '@mui/icons-material';
import { Box, Chip, Container, Grid, Typography, useTheme } from '@mui/material';
import React from 'react';

export const SecurityFooter: React.FC = () => {
     const theme = useTheme();

     return (
          <Box
               component='footer'
               sx={{
                    bgcolor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.7)' : 'rgba(255,255,255,0.9)',
                    backdropFilter: 'blur(10px)',
                    borderTop: `1px solid ${theme.palette.divider}`,
                    mt: 'auto',
                    py: 2,
               }}
          >
               <Container maxWidth='lg'>
                    <Grid
                         container
                         spacing={2}
                         alignItems='center'
                    >
                         <Grid
                              item
                              xs={12}
                              md={8}
                         >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                   <SecurityIcon
                                        sx={{
                                             fontSize: 20,
                                             color: theme.palette.success.main,
                                        }}
                                   />
                                   <Typography
                                        variant='caption'
                                        color='text.secondary'
                                        sx={{ fontSize: '0.75rem' }}
                                   >
                                        © 2025 IS Cantina - Sistema protegido com criptografia SSL/TLS 256-bit
                                   </Typography>
                              </Box>
                              <Typography
                                   variant='caption'
                                   color='text.secondary'
                                   sx={{ fontSize: '0.7rem', mt: 0.5, display: 'block' }}
                              >
                                   Dados pessoais e financeiros protegidos conforme LGPD
                              </Typography>
                         </Grid>

                         <Grid
                              item
                              xs={12}
                              md={4}
                         >
                              <Box
                                   sx={{
                                        display: 'flex',
                                        justifyContent: { xs: 'flex-start', md: 'flex-end' },
                                        gap: 1,
                                        flexWrap: 'wrap',
                                   }}
                              >
                                   <Chip
                                        icon={<LockIcon fontSize='small' />}
                                        label='SSL Ativo'
                                        color='success'
                                        size='small'
                                        variant='outlined'
                                        sx={{ fontSize: '0.7rem', height: 24 }}
                                   />
                                   <Chip
                                        icon={<ShieldIcon fontSize='small' />}
                                        label='LGPD'
                                        color='info'
                                        size='small'
                                        variant='outlined'
                                        sx={{ fontSize: '0.7rem', height: 24 }}
                                   />
                                   <Chip
                                        icon={<SecurityIcon fontSize='small' />}
                                        label='Verificado'
                                        color='primary'
                                        size='small'
                                        variant='outlined'
                                        sx={{ fontSize: '0.7rem', height: 24 }}
                                   />
                              </Box>
                         </Grid>
                    </Grid>
               </Container>
          </Box>
     );
};

export default SecurityFooter;
